/**
 * @desc 供应商新增/修改信息提交
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierInfoSaveRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/submitApprove`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
